import { defineFormConfig } from "./defineFormConfig";
import type { DefineFormConfigInput, FilterConfigResult } from "./types";

/**
 * Создаёт filter-конфиг поверх `defineFormConfig`. \
 * Начальные значения и цель кнопки «Сбросить» вычисляются через `defaults()`.
 * Кросс-полевая ревалидация после `setValue` — через {@link FieldValidationRules.deps} в декларациях (как у обычной формы).
 *
 * @template TForm тип значений filter-формы
 * @template TDomain тип доменного фильтра
 * @param input декларация полей фильтра
 * @returns декларативный filter-конфиг
 */
export function defineFilterConfig<TForm extends object, TDomain extends object, TContext = void>(
    input: DefineFormConfigInput<TForm, TDomain, TContext>,
): FilterConfigResult<TForm, TDomain, TContext> {
    return defineFormConfig(input);
}
